module.exports = __webpack_public_path__ + "static/media/iconTwitter.21e55d6d.svg";